<template>
  <div>
    <v-card>
      <create-campaign-crypto
        @onCreated="
          formDialog = false;
          camapaignList.unshift($event);
        "
        @onClose="formDialog = false"
        :dialog="formDialog"
      />
      <v-card-title>
        <v-layout row wrap align-center>
          <v-flex sm6 xs12 d-flex>
            <v-toolbar flat color="white">
              <v-toolbar-title>Campaign Crypto</v-toolbar-title>
              <v-divider class="mx-2" inset vertical></v-divider>
              <v-btn color="primary" fab dark @click="formDialog = true">
                <v-icon color="black">add</v-icon>
              </v-btn>
            </v-toolbar>
          </v-flex>
          <v-flex sm6 xs12 d-flex>
            <v-layout row wrap>
              <v-flex xs12 d-flex>
                <v-select
                  :items="[
                    { name: 'All type', value: 'all' },
                    { name: 'Airdrop', value: 'airdrop' },
                    { name: 'Redeem', value: 'redeem' },
                  ]"
                  item-text="name"
                  item-value="value"
                  v-model="filterType"
                  style="width: 40%"
                  class="pr-2"
                >
                </v-select>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search name"
                  single-line
                  hide-details
                  style="width: 60%"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <campaign-crypto-table
        :isLoading="isLoading"
        :headers="headers"
        :search="search"
        :filterType="filterType"
        :items="camapaignList"
        :campaignDetail="campaignDetail"
        @toEdit="toEdit($event)"
      />
    </v-card>
    <EditCampaignCrypto
      @onEdited="editedCampaign($event)"
      @onClose="editDialog = false"
      :dialog="editDialog"
      :form="selectedItem"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import EditCampaignCrypto from "@/components/back-office/CampaignCrypto/EditCampaignCryptoDialog.vue";
import CampaignCryptoTable from "@/components/back-office/CampaignCrypto/CampaignCryptoTable.vue";
import CreateCampaignCrypto from "@/components/back-office/CampaignCrypto/CreateCampaignCrypto.vue";
export default {
  data() {
    return {
      editDialog: false,
      formDialog: false,
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
        },
        {
          text: "Campaign code",
          align: "center",
          sortable: false,
        },
        {
          text: "Campaign image",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Category",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Campaign name(TH)",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Campaign name(EN)",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Description(TH)",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Description(EN)",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Used/Total",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Amount point",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Amount token",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Start",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "End",
          align: "center",
          sortable: false,
          value: "",
        },

        { text: "Transaction", align: "center", sortable: false, value: "fat" },
        { text: "Status", align: "center", sortable: false, value: "fat" },
        { text: "", align: "center", sortable: false, value: "fat" },
      ],
      search: "",
      filterType: "all",
      isLoading: false,
      levelList: [
        {
          name: "Standard",
          value: 1,
        },
        {
          name: "Silver",
          value: 2,
        },
        {
          name: "Gold",
          value: 3,
        },
        {
          name: "Platinum",
          value: 4,
        },
        {
          name: "VIP",
          value: 5,
        },
      ],
      categoryList: [
        {
          name: "Food delivery",
          value: 1,
        },
        {
          name: "Messenger",
          value: 2,
        },
      ],
      orderList: [
        {
          name: "Food delivery",
          value: 1,
        },
        {
          name: "Messenger",
          value: 2,
        },
      ],
      unitList: [
        {
          name: "%",
          value: 2,
        },
        {
          name: "฿",
          value: 1,
        },
      ],
      camapaignList: [],
      selectedItem: {},
    };
  },
  components: {
    "campaign-crypto-table": CampaignCryptoTable,
    "create-campaign-crypto": CreateCampaignCrypto,
    EditCampaignCrypto,
  },
  computed: {
    ...mapState({
      campaignDetail: (state) => state.campaigns.campaignRewardDetail,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
  },
  methods: {
    ...mapActions({
      fetchCampaignCrypto: "campaigns/fetchCampaignCrypto",
    }),
    toEdit(item) {
      let campaign = JSON.parse(JSON.stringify(item));
      this.selectedItem = {
        campaign_crypto_id: campaign.campaign_crypto_id,
        campaign_amount_redeem: campaign.campaign_crypto_amount_redeem,
        campaign_amount_per_user: campaign.campaign_crypto_amount_per_user,
        campaign_type: campaign.campaign_crypto_type,
        campaign_amount_point: campaign.campaign_crypto_amount_point,
        campaign_amount_token: campaign.campaign_crypto_amount_token,
        campaign_start_date: campaign.campaign_crypto_start_date,
        campaign_end_date: campaign.campaign_crypto_end_date,
        campaign_image: campaign.campaign_crypto_image,
        campaign_title_th: campaign.campaign_crypto_title_th,
        campaign_title_en: campaign.campaign_crypto_title_en,
        campaign_description_th: campaign.campaign_crypto_description_th,
        campaign_description_en: campaign.campaign_crypto_description_en,
        campaign_condition_detail: campaign.campaign_crypto_condition_detail,
      };
      console.log(item);
      this.editDialog = true;
    },
    editedCampaign(result) {
      this.editDialog = false;
      let index = this.camapaignList.findIndex(
        (val) => val.campaign_crypto_id == result.campaign_crypto_id
      );
      this.camapaignList.splice(index, 1, result);
    },
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "App Campaign Reward",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  async created() {
    this.isLoading = true;
    this.camapaignList = await this.fetchCampaignCrypto();
    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
</style>